import type { IconNode } from '../types';

/**
 * @name pretzel
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMjAgMTktNi41LTYuNUE0LjkgNC45IDAgMCAxIDEyIDlhNSA1IDAgMCAxIDEwIDBBMTAgMTAgMCAwIDEgMiA5YTUgNSAwIDEgMSAxMCAwYzAgMS40LS42IDIuNi0xLjUgMy41TDQgMTkiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/pretzel
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const pretzel: IconNode = [
  [
    'path',
    {
      d: 'm20 19-6.5-6.5A4.9 4.9 0 0 1 12 9a5 5 0 0 1 10 0A10 10 0 0 1 2 9a5 5 0 1 1 10 0c0 1.4-.6 2.6-1.5 3.5L4 19',
      key: '1pyo89',
    },
  ],
];

export default pretzel;
